import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import innerCover from '.././assets/images/offers-cover.jpg'
import pressDetail from '../assets/images/press-four.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import ThumbPressItem from './ThumbPressItem';
import thumbTwo from '../assets/images/thumb-two.jpg'
import thumbThree from '../assets/images/thumb-three.jpg'
import thumbFive from '../assets/images/thumb-five.jpg'
import { Link } from 'react-router-dom';

function KanifushiEnrichesCulinaryExperiencesWithTheNewLanternBar() {
    const presstextone = ["<p>The blissfully tropical Maldivian resort, Atmosphere Kanifushi recently unveiled a new overwater bar, poetically named the Lantern Bar. Opened on 12th December 2022, the Asian fusion bar is located on southern side of Kanifushi island, perched over a crystal-clear aquamarine lagoon, just like a lantern illuminating the ocean waters.</p><p>An extension to the award-winning restaurant, Just Veg, this charming new outlet is all about slowing down, experiencing glorious sunset hues, and easing into the night in the lantern-lit ambiance as the stars come up in the night sky.</p><p>Guests can savour flavourful vegetarian platters that reimagine iconic Asian dishes with an artistic flair. Picture spring rolls and kebabs, crostini and falafels, all served with handmade dips and sides. Complementing the dishes are a collection of ‘Elixirs’ – delicious, healing mocktails prepared by an Ayurvedic doctor that not just woo the taste buds but also leave the body nourished and rejuvenated. Elements from nature like hibiscus and aloe vera blend with classic mixers to create magic in a glass, and beyond.</p><p>The name Lantern Bar is inspired by the symbolism of light as pure, optimistic, triumphant, and even divine. Light and dark, sunrise and sunset, the eternal phases of life are perceived as a harmonious totality in many East Asian cultures. In a far-off island such as Atmosphere Kanifushi, one comes even closer to such natural rhythms.</p><p>From the logo and décor to the menu – there’s a subtle ode to lanterns and lights throughout the experience. Take for instance the fascinating mural framing the bar counter that depicts a local scene half in paint and the other half in metal, representing the duality of light and dark.</p><p>Lantern Bar serves a Sampler Platter Menu from 5pm to 8pm. And, from 8pm to 10.30pm, guests can enjoy the dinner menu from Just Veg, a specialty restaurant with contemporary, plant-based cuisine with recipes from Arabic, Indian, and Mediterranean regions.</p><p>Mei P. Pun, the General Manager of Atmosphere Kanifushi, says, I am thrilled to announce the opening of the Lantern Bar that marks yet another exciting landmark in Kanifushi’s charming history. We are passionate about offering holistic health and Food & Beverage concepts that that fills our guests with joy and I cannot wait for them to experience this first hand.</p><p>An exhilarating 35-minute Sea Plane ride from Malé International Airport brings guests to Atmosphere Kanifushi, located off the beaten track at a secluded edge of the Lhaviyani Atoll. The resort offers 7 villas categories with 132 detached sunset bungalows and 40 overwater villas offering complete privacy. With the premium holiday plan, Kanifushi PlanTM guests enjoy a hassle-free, blissfully tropical island experience with dine-around and unlimited spirits and beverages, ocean excursions, snorkelling, daily activities, and entertainment all blended with the stay.</p>"]

    const thumCardData = [
        {
            id: 0, thumbCardImage: thumbTwo, 
            thumbCardTitle: 'Enjoy the best of the Maldives in complete privacy at the Atmosphere Kanifushi', 
            thumbCardDate: '10/11/2023',
            thumbPressLink:'/enjoy-the-best-of-the-maldives-in-complete-privacy-at-the-atmosphere-kanifushi'
        },
        
        {
            id: 1, 
            thumbCardImage: thumbThree, 
            thumbCardTitle: 'How To Elevate Your Plant-Based Cooking This Summer Season', 
            thumbCardDate: '08/11/2023',
            thumbPressLink:'/how-to-elevate-your-plant-based-cooking-this-summer-season'
        },

        {
            id: 2, 
            thumbCardImage: thumbFive, 
            thumbCardTitle: 'AKM Just Veg Hosts Chef Fabrizio Marino', 
            thumbCardDate: '05/11/2023',
            thumbPressLink:'/akm-just-veg-hosts-chef-fabrizio-marino'
        }
    ]

  return (
    <>
        <section>
            <div className='inner-cover header-space position-relative'>
                <div className='our-story position-absolute start-0 top-0 h-100'>
                    <img className='w-100 h-100' src={innerCover} title='Atmosphere' alt='Atmosphere' />
                </div>
                <div className='page-inner position-relative text-center'>
                    <div className='page-title d-flex justify-content-center'>
                        <h2 className='text-uppercase text-white georgia py-xl-4 py-3 px-5'>Press Releases</h2>
                    </div>
                    <Breadcrumb className='d-flex justify-content-center mt-4 text-white'>
                        <Breadcrumb.Item><Link to='/'>Home</Link> </Breadcrumb.Item>
                        <Breadcrumb.Item><Link to='/media-center'>Media</Link> </Breadcrumb.Item>
                        <Breadcrumb.Item active>Atmosphere Kanifushi Enriches Culinary Experiences With The New Lantern Bar</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
        </section>

        <section>
            <div className='press-details section-padding'>
                <div className='container'> 
                    <div className='row'>
                        <div className='col-12 mb-4'>
                            <Link className='w-auto btn primary theme-btn px-4 py-2 theme-outline-btn fw-medium text-uppercase border-theme form-control' to='/media-center'><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Back </Link>
                        </div>
                        <div className='col-md-8'>
                            <div className='press-article'>
                                <div className='press-img rounded-3 overflow-hidden'>
                                    <img className='w-100' src={pressDetail} alt=''/>
                                </div>
                                <div className='d-flex justify-content-between flex-wrap'>
                                    <div className='press-title'>
                                        <h3 className='georgia text-uppercase'>Atmosphere Kanifushi Enriches Culinary Experiences With The New Lantern Bar</h3>
                                        <span className='fw-medium mt-2 d-flex'>Dec 04, 2023 02:46 PM IST</span>
                                    </div>
                                    <div className='press-date pt-lg-4'>
                                        <span>25/10/2023</span>
                                    </div>
                                </div>
                                <div className='press-full-article'>
                                    <div className='press-text-card'>
                                        <div dangerouslySetInnerHTML={{ __html: presstextone }}></div>
                                    </div>
                                    {/* /press-text-card */}
                                </div>
                            </div>
                            <div className='press-article-pagination'>
                                <Link className='w-auto btn primary theme-btn theme-outline-btn fw-medium text-uppercase border-theme form-control' to=''><FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Prev</Link>
                                <Link className='w-auto btn primary theme-btn theme-outline-btn fw-medium text-uppercase border-theme form-control ms-3' to=''>Next <FontAwesomeIcon icon={faAngleRight} className='ms-2' /></Link>
                            </div>
                        </div>
                        {/* /col-md-8 */}
                        <div className='col-md-4'>
                            <div className='more-articles-sidebar mt-md-0 mt-5'>
                                <div className='dashed-heading position-relative'>
                                    <h5 className='georgia text-uppercase'><span>More articles</span></h5>
                                </div>
                                <div className='thumb-articles mt-md-4 mt-3 pt-md-2'>
                                    {thumCardData.map((thumbCard) =>(
                                        <ThumbPressItem
                                            key={thumbCard.id}
                                            thumbCardImage={thumbCard.thumbCardImage}
                                            thumbCardTitle={thumbCard.thumbCardTitle}
                                            thumbCardDate={thumbCard.thumbCardDate}
                                            thumbPressLink={thumbCard.thumbPressLink}
                                        />  
                                    ))}                                    
                                </div>
                                <div className='press-article-pagination'>
                                    <Link className='w-auto btn primary theme-btn theme-outline-btn fw-medium text-uppercase border-theme form-control' to='/media-center'> VIEW ALL <FontAwesomeIcon icon={faAngleRight} className='ms-2' /></Link>
                                </div>
                            </div>
                        </div>
                        {/* /col-md-4 */}
                    </div>
                </div>
            </div>
        </section>


    </>
  )
}

export default KanifushiEnrichesCulinaryExperiencesWithTheNewLanternBar